<template>
  <div class="planClassPage">
    <!--课时.-->
    <div class="plan">
      <div class="movePlan">
        <div class="move moveRight " @click="moveUI(-1)">
          <el-button :disabled="moveLeft" class="icon icon-youla" icon="el-icon-arrow-right"></el-button>
        </div>
        <div class="moveUl">
          <ul id="moveUI" :style="{ left: `${moveValue}px` }">
            <li
              v-for="(item, i) of planClassList"
              :key="i"
              @click="clickPlanLi(i)"
              :class="{ active: i === selPlanInfo.selPlanIndex }"
            >
              <h4>{{ item.ClassName }}</h4>
              <p>{{ item.CreateDate }}</p>
              <a class="cancel-macth" href="javascript:;" @click="cancelMatch(i)">
                <i class="el-icon-circle-close"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="move moveLeft" @click="moveUI(1)">
          <el-button :disabled="moveValue >= 0" class="icon icon-xiangzuola " icon="el-icon-arrow-left"></el-button>
        </div>
      </div>
      <div class="matchingResource">
        <el-button @click="matchingResource" size="medium">匹配资源</el-button>
      </div>
    </div>
    <!--任务单.-->
    <div class="plan task" v-if="activeTab == 'taskChart'">
      <div class="movePlan">
        <div class="move moveRight" @click="moveUITask(-1)">
          <el-button :disabled="moveLeftTask" class="icon icon-youla" icon="el-icon-arrow-right"></el-button>
        </div>
        <div class="moveUl">
          <ul id="moveUITask" :style="{ left: `${moveValueTask}px` }">
            <li
              v-for="(item, i) of planTaskList"
              :key="i"
              @click="clickPlanLiTask(i)"
              :class="{ active: i === selPlanInfo.selTaskIndex }"
            >
              <h4>{{ item.TaskName }}</h4>
              <p>{{ item.School }}</p>
              <p>{{ item.Teacher }}</p>
            </li>
          </ul>
        </div>
        <div class="move moveLeft " @click="moveUITask(1)">
          <el-button :disabled="moveValueTask >= 0" class="icon icon-xiangzuola " icon="el-icon-arrow-left"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanClassCom",
  props: {
    //上课信息.
    planClassList: {
      type: Array,
      required: false,
    },
    //任务单列表数据
    planTaskList: {
      type: Array,
      required: false,
    },
    // 当前是否选择了任务单
    selPlanInfo: {
      type: Object,
    },
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      liWidth: 170, //每次移动的宽度.
      moveValue: 0, // 当前移动的距离
      moveLeft: true, //是否右以左拉.
      uiDom: null, // ui
      liWidthTask: 340, //每次移动的宽度.
      moveValueTask: 0, // 当前移动的距离
      moveLeftTask: false, //是否右以左拉.
      uiDomTask: null, // ui
      //
      domOK: false,
    };
  },
  mounted() {
    this.domOK = true;
  },
  created() {
    window.PlanClassComData = this;
  },
  watch: {
    domOK(Val, oldVal) {
      if (Val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.uiDom = document.getElementById("moveUI");
      this.uiDomTask = document.getElementById("moveUITask");
      this.moveLeft = false;
      this.moveLeftTask = false;
      this.moveValueTask = 0;
      this.moveValue = 0;
    },
    cancelMatch(planClassIndex) {
      console.log("cancel-match", planClassIndex);
      this.$emit("cancel-match", planClassIndex);
    },
    //左右移动.
    moveUI(i) {
      //1.获取ul宽度,和moveUI宽度.
      //2. 如果ul宽度小于moveUI宽度, 不需要左右滑动.
      //3. 如果ul宽度大于moveUI宽度, 则需要左右滑动.

      let uiWidth = parseFloat(getComputedStyle(this.uiDom).width);
      let uiParentWidth = parseFloat(getComputedStyle(this.uiDom.parentElement).width);

      if (uiWidth > uiParentWidth) {
        //ui宽度+当前移动的距离 . 依然大于uiParent则可以左移.
        if (this.moveValue + uiWidth > uiParentWidth) {
          this.moveValue += i * this.liWidth;
          //预判
          if (this.moveValue + uiWidth <= uiParentWidth) {
            this.moveLeft = true;
          }
        } else {
          //小于当前移动距离,则可以右移.
          this.moveValue += i * this.liWidth;
          //预判
          if (this.moveValue + uiWidth > uiParentWidth) {
            this.moveLeft = false;
          }
        }
      }
    },
    //选中在某班上的课时.
    clickPlanLi(i) {
      this.selPlanInfo.selPlanIndex = i;
      this.$emit("clickPlanLi", i);
    },
    //匹配资源
    matchingResource() {
      this.$emit("ppClassList", true);
    },
    //左右移动.
    moveUITask(i) {
      //1.获取ul宽度,和moveUI宽度.
      //2. 如果ul宽度小于moveUI宽度, 不需要左右滑动.
      //3. 如果ul宽度大于moveUI宽度, 则需要左右滑动.
      this.uiDomTask = document.getElementById("moveUITask");

      let uiWidth = parseFloat(getComputedStyle(this.uiDomTask).width);
      let uiParentWidth = parseFloat(getComputedStyle(this.uiDomTask.parentElement).width);

      // return;
      if (uiWidth > uiParentWidth) {
        //ui宽度+当前移动的距离 . 依然大于uiParent则可以左移.
        if (this.moveValueTask + uiWidth > uiParentWidth) {
          this.moveValueTask += i * this.liWidthTask;
          //预判
          if (this.moveValueTask + uiWidth <= uiParentWidth) {
            this.moveLeftTask = true;
          }
        } else {
          //小于当前移动距离,则可以右移.
          this.moveValueTask += i * this.liWidthTask;
          //预判
          if (this.moveValueTask + uiWidth > uiParentWidth) {
            this.moveLeftTask = false;
          }
        }
      }
    },
    //选中在某班上的课时.
    clickPlanLiTask(i) {
      this.selPlanInfo.selTaskIndex = i;
      this.$emit("clickTaskLi", i);
    },
  },
};
</script>

<style lang="less" scoped>
.planClassPage {
  .plan {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    //左右移动课时区
    .movePlan {
      flex: 1 1 auto;
      display: flex;
      position: relative;
      //左右按钮开始
      .move {
        position: absolute;
        width: 30px;

        i {
          font-size: 22px;
        }

        line-height: 42px;

        &:hover {
          cursor: pointer;
        }

        .el-button {
          width: 30px;
          padding: 0;
          border: 0;
          font-size: 22px;
          i[class^=el-icon-] {
            font-weight: 600;
          }

          &:hover {
            background: transparent;
          }

          &:focus {
            background: transparent;
          }
        }
      }

      .moveLeft {
        left: 0;
      }

      .moveRight {
        right: 0;
      }

      .moveUl {
        position: absolute;
        left: 30px;
        right: 30px;
        overflow: hidden;
        height: 44px;

        ul {
          transition: left linear 0.3s;
          position: absolute;
          text-align: left;
          white-space: nowrap;

          li {
            position: relative;
            text-align: center;
            display: inline-block;
            width: 150px;

            &.active {
              border-bottom: 2px solid #1e87f0;
            }

            margin: 0 10px;

            &:hover {
              border-bottom: 2px solid rgba(34, 139, 241, 0.76);
              cursor: pointer;
            }

            a.cancel-macth {
              position: absolute;
              right: 0;
              top: 0;
              font-size: 18px;
              text-decoration: none;
              color: red;
            }
            p {
              line-height: unset;
            }
          }
        }
      }

      //左右按钮结束
    }

    //匹配资源区
    .matchingResource {
      width: 98px;
      margin-left: 80px;
    }
  }

  .plan.task {
    height: 64px;
    margin-bottom: 0;

    .movePlan {
      .moveUl {
        height: 65px;
        ul {
          li {
            width: 320px;
            text-align: center;
            h4,
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/PlanClassCom.vue